/** What K08 ignores at the end of both texts (`rtrim(x, ' ,.:')`, CorpusLinkTargetQueries). */
var IGNORED_TAIL = /[ ,.:]+$/;
var push = function (out, text, changed) {
    var last = out[out.length - 1];
    if (last && last.changed === changed)
        last.text += text;
    else
        out.push({ text: text, changed: changed });
};
/**
 * Where a K08 link text and the target heading differ (CZNA-1408): both texts split into
 * runs, the characters outside their longest common subsequence marked. It compares what
 * the check compares — the trailing " ,.:" is ignored, so it is never marked, and two texts
 * that differ only there have no mark at all (the check would not have reported them).
 *
 * @returns the segments of `a` and of `b`, in that order
 */
export var diffTexts = function (a, b) {
    var headA = a.replace(IGNORED_TAIL, '');
    var headB = b.replace(IGNORED_TAIL, '');
    var x = Array.from(headA);
    var y = Array.from(headB);
    // lcs[i][j] = length of the LCS of x[i..] and y[j..].
    var lcs = Array.from({ length: x.length + 1 }, function () { return new Array(y.length + 1).fill(0); });
    for (var i_1 = x.length - 1; i_1 >= 0; i_1 -= 1) {
        for (var j_1 = y.length - 1; j_1 >= 0; j_1 -= 1) {
            lcs[i_1][j_1] = x[i_1] === y[j_1] ? lcs[i_1 + 1][j_1 + 1] + 1 : Math.max(lcs[i_1 + 1][j_1], lcs[i_1][j_1 + 1]);
        }
    }
    var outA = [];
    var outB = [];
    var i = 0;
    var j = 0;
    while (i < x.length || j < y.length) {
        if (i < x.length && j < y.length && x[i] === y[j]) {
            push(outA, x[i], false);
            push(outB, y[j], false);
            i += 1;
            j += 1;
        }
        else if (j < y.length && (i === x.length || lcs[i][j + 1] >= lcs[i + 1][j])) {
            push(outB, y[j], true);
            j += 1;
        }
        else {
            push(outA, x[i], true);
            i += 1;
        }
    }
    if (a.length > headA.length)
        push(outA, a.slice(headA.length), false);
    if (b.length > headB.length)
        push(outB, b.slice(headB.length), false);
    return [outA, outB];
};
